import { __module as t } from "../../../_virtual/isTaxID.js";
import { a as r } from "./util/assertString.js";
import "./util/algorithms.js";
import { i as e } from "./isDate.js";
import { __exports as n } from "../../../_virtual/algorithms.js";
!function (t, a) {
  function c(t) {
    return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = function (t) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "en-US";
    (0, i.default)(t);
    var e = t.slice(0);
    if (r in v) return r in g && (e = e.replace(g[r], "")), !!v[r].test(e) && (!(r in h) || h[r](e));
    throw Error("Invalid locale '".concat(r, "'"));
  };
  var i = u(r),
    s = function (t) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== c(t) && "function" != typeof t) return {
        default: t
      };
      var r = l();
      if (r && r.has(t)) return r.get(t);
      var e = {},
        n = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var a in t) if (Object.prototype.hasOwnProperty.call(t, a)) {
        var i = n ? Object.getOwnPropertyDescriptor(t, a) : null;
        i && (i.get || i.set) ? Object.defineProperty(e, a, i) : e[a] = t[a];
      }
      return e.default = t, r && r.set(t, e), e;
    }(n),
    o = u(e);
  function l() {
    if ("function" != typeof WeakMap) return null;
    var t = new WeakMap();
    return l = function l() {
      return t;
    }, t;
  }
  function u(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function f(t, r) {
    (null == r || r > t.length) && (r = t.length);
    for (var e = 0, n = Array(r); e < r; e++) n[e] = t[e];
    return n;
  }
  var p = {
    andover: ["10", "12"],
    atlanta: ["60", "67"],
    austin: ["50", "53"],
    brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
    cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
    fresno: ["15", "24"],
    internet: ["20", "26", "27", "45", "46", "47"],
    kansas: ["40", "44"],
    memphis: ["94", "95"],
    ogden: ["80", "90"],
    philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
    sba: ["31"]
  };
  function d(t) {
    for (var r = !1, e = !1, n = 0; n < 3; n++) if (!r && /[AEIOU]/.test(t[n])) r = !0;else if (!e && r && "X" === t[n]) e = !0;else if (n > 0 && (r && !e && !/[AEIOU]/.test(t[n]) || e && !/X/.test(t[n]))) return !1;
    return !0;
  }
  var v = {
    "bg-BG": /^\d{10}$/,
    "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
    "de-AT": /^\d{9}$/,
    "de-DE": /^[1-9]\d{10}$/,
    "dk-DK": /^\d{6}-{0,1}\d{4}$/,
    "el-CY": /^[09]\d{7}[A-Z]$/,
    "el-GR": /^([0-4]|[7-9])\d{8}$/,
    "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
    "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
    "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    "fr-BE": /^\d{11}$/,
    "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    "fr-LU": /^\d{13}$/,
    "hr-HR": /^\d{11}$/,
    "hu-HU": /^8\d{9}$/,
    "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    "lv-LV": /^\d{6}-{0,1}\d{5}$/,
    "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    "nl-NL": /^\d{9}$/,
    "pl-PL": /^\d{10,11}$/,
    "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
    "pt-PT": /^\d{9}$/,
    "ro-RO": /^\d{13}$/,
    "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
    "sl-SI": /^[1-9]\d{7}$/,
    "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
  };
  v["lb-LU"] = v["fr-LU"], v["lt-LT"] = v["et-EE"], v["nl-BE"] = v["fr-BE"];
  var h = {
    "bg-BG": function bgBG(t) {
      var r = t.slice(0, 2),
        e = parseInt(t.slice(2, 4), 10);
      e > 40 ? (e -= 40, r = "20".concat(r)) : e > 20 ? (e -= 20, r = "18".concat(r)) : r = "19".concat(r), e < 10 && (e = "0".concat(e));
      var n = "".concat(r, "/").concat(e, "/").concat(t.slice(4, 6));
      if (!(0, o.default)(n, "YYYY/MM/DD")) return !1;
      for (var a = t.split("").map(function (t) {
          return parseInt(t, 10);
        }), c = [2, 4, 8, 5, 10, 9, 7, 3, 6], i = 0, s = 0; s < c.length; s++) i += a[s] * c[s];
      return (i = i % 11 == 10 ? 0 : i % 11) === a[9];
    },
    "cs-CZ": function csCZ(t) {
      var r = parseInt((t = t.replace(/\W/, "")).slice(0, 2), 10);
      if (10 === t.length) r = r < 54 ? "20".concat(r) : "19".concat(r);else {
        if ("000" === t.slice(6) || !(r < 54)) return !1;
        r = "19".concat(r);
      }
      3 === r.length && (r = [r.slice(0, 2), "0", r.slice(2)].join(""));
      var e = parseInt(t.slice(2, 4), 10);
      if (e > 50 && (e -= 50), e > 20) {
        if (2004 > parseInt(r, 10)) return !1;
        e -= 20;
      }
      e < 10 && (e = "0".concat(e));
      var n = "".concat(r, "/").concat(e, "/").concat(t.slice(4, 6));
      if (!(0, o.default)(n, "YYYY/MM/DD")) return !1;
      if (10 === t.length && parseInt(t, 10) % 11 != 0) {
        var a = parseInt(t.slice(0, 9), 10) % 11;
        if (!(1986 > parseInt(r, 10)) || 10 !== a || 0 !== parseInt(t.slice(9), 10)) return !1;
      }
      return !0;
    },
    "de-AT": function deAT(t) {
      return s.luhnCheck(t);
    },
    "de-DE": function deDE(t) {
      for (var r = t.split("").map(function (t) {
          return parseInt(t, 10);
        }), e = [], n = 0; n < r.length - 1; n++) {
        e.push("");
        for (var a = 0; a < r.length - 1; a++) r[n] === r[a] && (e[n] += a);
      }
      if (2 !== (e = e.filter(function (t) {
        return t.length > 1;
      })).length && 3 !== e.length) return !1;
      if (3 === e[0].length) {
        for (var c = e[0].split("").map(function (t) {
            return parseInt(t, 10);
          }), i = 0, o = 0; o < c.length - 1; o++) c[o] + 1 === c[o + 1] && (i += 1);
        if (2 === i) return !1;
      }
      return s.iso7064Check(t);
    },
    "dk-DK": function dkDK(t) {
      var r = parseInt((t = t.replace(/\W/, "")).slice(4, 6), 10);
      switch (t.slice(6, 7)) {
        case "0":
        case "1":
        case "2":
        case "3":
          r = "19".concat(r);
          break;
        case "4":
        case "9":
          r = r < 37 ? "20".concat(r) : "19".concat(r);
          break;
        default:
          if (r < 37) r = "20".concat(r);else {
            if (!(r > 58)) return !1;
            r = "18".concat(r);
          }
      }
      3 === r.length && (r = [r.slice(0, 2), "0", r.slice(2)].join(""));
      var e = "".concat(r, "/").concat(t.slice(2, 4), "/").concat(t.slice(0, 2));
      if (!(0, o.default)(e, "YYYY/MM/DD")) return !1;
      for (var n = t.split("").map(function (t) {
          return parseInt(t, 10);
        }), a = 0, c = 4, i = 0; i < 9; i++) a += n[i] * c, 1 == (c -= 1) && (c = 7);
      return 1 != (a %= 11) && (0 === a ? 0 === n[9] : n[9] === 11 - a);
    },
    "el-CY": function elCY(t) {
      for (var r = t.slice(0, 8).split("").map(function (t) {
          return parseInt(t, 10);
        }), e = 0, n = 1; n < r.length; n += 2) e += r[n];
      for (var a = 0; a < r.length; a += 2) r[a] < 2 ? e += 1 - r[a] : (e += 2 * (r[a] - 2) + 5, r[a] > 4 && (e += 2));
      return String.fromCharCode(e % 26 + 65) === t.charAt(8);
    },
    "el-GR": function elGR(t) {
      for (var r = t.split("").map(function (t) {
          return parseInt(t, 10);
        }), e = 0, n = 0; n < 8; n++) e += r[n] * Math.pow(2, 8 - n);
      return e % 11 % 10 === r[8];
    },
    "en-IE": function enIE(t) {
      var r = s.reverseMultiplyAndSum(t.split("").slice(0, 7).map(function (t) {
        return parseInt(t, 10);
      }), 8);
      return (9 === t.length && "W" !== t[8] && (r += (t[8].charCodeAt(0) - 64) * 9), 0 == (r %= 23)) ? "W" === t[7].toUpperCase() : t[7].toUpperCase() === String.fromCharCode(64 + r);
    },
    "en-US": function enUS(t) {
      return -1 !== function () {
        var t,
          r = [];
        for (var e in p) p.hasOwnProperty(e) && r.push.apply(r, function (t) {
          if (Array.isArray(t)) return f(t);
        }(t = p[e]) || function (t) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
        }(t) || function (t, r) {
          if (t) {
            if ("string" == typeof t) return f(t, r);
            var e = Object.prototype.toString.call(t).slice(8, -1);
            if ("Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e) return Array.from(t);
            if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return f(t, r);
          }
        }(t) || function () {
          throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }());
        return r;
      }().indexOf(t.substr(0, 2));
    },
    "es-ES": function esES(t) {
      var r = t.toUpperCase().split("");
      if (isNaN(parseInt(r[0], 10)) && r.length > 1) {
        var e = 0;
        switch (r[0]) {
          case "Y":
            e = 1;
            break;
          case "Z":
            e = 2;
        }
        r.splice(0, 1, e);
      } else for (; r.length < 9;) r.unshift(0);
      var n = parseInt((r = r.join("")).slice(0, 8), 10) % 23;
      return r[8] === ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"][n];
    },
    "et-EE": function etEE(t) {
      var r = t.slice(1, 3);
      switch (t.slice(0, 1)) {
        case "1":
        case "2":
          r = "18".concat(r);
          break;
        case "3":
        case "4":
          r = "19".concat(r);
          break;
        default:
          r = "20".concat(r);
      }
      var e = "".concat(r, "/").concat(t.slice(3, 5), "/").concat(t.slice(5, 7));
      if (!(0, o.default)(e, "YYYY/MM/DD")) return !1;
      for (var n = t.split("").map(function (t) {
          return parseInt(t, 10);
        }), a = 0, c = 1, i = 0; i < 10; i++) a += n[i] * c, 10 === (c += 1) && (c = 1);
      if (a % 11 == 10) {
        a = 0, c = 3;
        for (var s = 0; s < 10; s++) a += n[s] * c, 10 === (c += 1) && (c = 1);
        if (a % 11 == 10) return 0 === n[10];
      }
      return a % 11 === n[10];
    },
    "fi-FI": function fiFI(t) {
      var r = t.slice(4, 6);
      switch (t.slice(6, 7)) {
        case "+":
          r = "18".concat(r);
          break;
        case "-":
          r = "19".concat(r);
          break;
        default:
          r = "20".concat(r);
      }
      var e = "".concat(r, "/").concat(t.slice(2, 4), "/").concat(t.slice(0, 2));
      if (!(0, o.default)(e, "YYYY/MM/DD")) return !1;
      var n = parseInt(t.slice(0, 6) + t.slice(7, 10), 10) % 31;
      return n < 10 ? n === parseInt(t.slice(10), 10) : ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"][n -= 10] === t.slice(10);
    },
    "fr-BE": function frBE(t) {
      if ("00" !== t.slice(2, 4) || "00" !== t.slice(4, 6)) {
        var r = "".concat(t.slice(0, 2), "/").concat(t.slice(2, 4), "/").concat(t.slice(4, 6));
        if (!(0, o.default)(r, "YY/MM/DD")) return !1;
      }
      var e = 97 - parseInt(t.slice(0, 9), 10) % 97,
        n = parseInt(t.slice(9, 11), 10);
      return e === n || (e = 97 - parseInt("2".concat(t.slice(0, 9)), 10) % 97) === n;
    },
    "fr-FR": function frFR(t) {
      return parseInt((t = t.replace(/\s/g, "")).slice(0, 10), 10) % 511 === parseInt(t.slice(10, 13), 10);
    },
    "fr-LU": function frLU(t) {
      var r = "".concat(t.slice(0, 4), "/").concat(t.slice(4, 6), "/").concat(t.slice(6, 8));
      return !!((0, o.default)(r, "YYYY/MM/DD") && s.luhnCheck(t.slice(0, 12))) && s.verhoeffCheck("".concat(t.slice(0, 11)).concat(t[12]));
    },
    "hr-HR": function hrHR(t) {
      return s.iso7064Check(t);
    },
    "hu-HU": function huHU(t) {
      for (var r = t.split("").map(function (t) {
          return parseInt(t, 10);
        }), e = 8, n = 1; n < 9; n++) e += r[n] * (n + 1);
      return e % 11 === r[9];
    },
    "it-IT": function itIT(t) {
      var r = t.toUpperCase().split("");
      if (!d(r.slice(0, 3)) || !d(r.slice(3, 6))) return !1;
      for (var e = {
          L: "0",
          M: "1",
          N: "2",
          P: "3",
          Q: "4",
          R: "5",
          S: "6",
          T: "7",
          U: "8",
          V: "9"
        }, n = 0, a = [6, 7, 9, 10, 12, 13, 14]; n < a.length; n++) {
        var c = a[n];
        r[c] in e && r.splice(c, 1, e[r[c]]);
      }
      var i = {
          A: "01",
          B: "02",
          C: "03",
          D: "04",
          E: "05",
          H: "06",
          L: "07",
          M: "08",
          P: "09",
          R: "10",
          S: "11",
          T: "12"
        }[r[8]],
        s = parseInt(r[9] + r[10], 10);
      s > 40 && (s -= 40), s < 10 && (s = "0".concat(s));
      var l = "".concat(r[6]).concat(r[7], "/").concat(i, "/").concat(s);
      if (!(0, o.default)(l, "YY/MM/DD")) return !1;
      for (var u = 0, f = 1; f < r.length - 1; f += 2) {
        var p = parseInt(r[f], 10);
        isNaN(p) && (p = r[f].charCodeAt(0) - 65), u += p;
      }
      for (var v = {
          A: 1,
          B: 0,
          C: 5,
          D: 7,
          E: 9,
          F: 13,
          G: 15,
          H: 17,
          I: 19,
          J: 21,
          K: 2,
          L: 4,
          M: 18,
          N: 20,
          O: 11,
          P: 3,
          Q: 6,
          R: 8,
          S: 12,
          T: 14,
          U: 16,
          V: 10,
          W: 22,
          X: 25,
          Y: 24,
          Z: 23,
          0: 1,
          1: 0
        }, h = 0; h < r.length - 1; h += 2) {
        var I = 0;
        if (r[h] in v) I = v[r[h]];else {
          var g = parseInt(r[h], 10);
          I = 2 * g + 1, g > 4 && (I += 2);
        }
        u += I;
      }
      return String.fromCharCode(65 + u % 26) === r[15];
    },
    "lv-LV": function lvLV(t) {
      var r = (t = t.replace(/\W/, "")).slice(0, 2);
      if ("32" !== r) {
        if ("00" !== t.slice(2, 4)) {
          var e = t.slice(4, 6);
          switch (t[6]) {
            case "0":
              e = "18".concat(e);
              break;
            case "1":
              e = "19".concat(e);
              break;
            default:
              e = "20".concat(e);
          }
          var n = "".concat(e, "/").concat(t.slice(2, 4), "/").concat(r);
          if (!(0, o.default)(n, "YYYY/MM/DD")) return !1;
        }
        for (var a = 1101, c = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], i = 0; i < t.length - 1; i++) a -= parseInt(t[i], 10) * c[i];
        return parseInt(t[10], 10) === a % 11;
      }
      return !0;
    },
    "mt-MT": function mtMT(t) {
      if (9 !== t.length) {
        for (var r = t.toUpperCase().split(""); r.length < 8;) r.unshift(0);
        switch (t[7]) {
          case "A":
          case "P":
            if (0 === parseInt(r[6], 10)) return !1;
            break;
          default:
            var e = parseInt(r.join("").slice(0, 5), 10);
            if (e > 32e3 || e === parseInt(r.join("").slice(5, 7), 10)) return !1;
        }
      }
      return !0;
    },
    "nl-NL": function nlNL(t) {
      return s.reverseMultiplyAndSum(t.split("").slice(0, 8).map(function (t) {
        return parseInt(t, 10);
      }), 9) % 11 === parseInt(t[8], 10);
    },
    "pl-PL": function plPL(t) {
      if (10 === t.length) {
        for (var r = [6, 5, 7, 2, 3, 4, 5, 6, 7], e = 0, n = 0; n < r.length; n++) e += parseInt(t[n], 10) * r[n];
        return 10 != (e %= 11) && e === parseInt(t[9], 10);
      }
      var a = t.slice(0, 2),
        c = parseInt(t.slice(2, 4), 10);
      c > 80 ? (a = "18".concat(a), c -= 80) : c > 60 ? (a = "22".concat(a), c -= 60) : c > 40 ? (a = "21".concat(a), c -= 40) : c > 20 ? (a = "20".concat(a), c -= 20) : a = "19".concat(a), c < 10 && (c = "0".concat(c));
      var i = "".concat(a, "/").concat(c, "/").concat(t.slice(4, 6));
      if (!(0, o.default)(i, "YYYY/MM/DD")) return !1;
      for (var s = 0, l = 1, u = 0; u < t.length - 1; u++) s += parseInt(t[u], 10) * l % 10, (l += 2) > 10 ? l = 1 : 5 === l && (l += 2);
      return (s = 10 - s % 10) === parseInt(t[10], 10);
    },
    "pt-BR": function ptBR(t) {
      if (11 === t.length) {
        if (r = 0, "11111111111" === t || "22222222222" === t || "33333333333" === t || "44444444444" === t || "55555555555" === t || "66666666666" === t || "77777777777" === t || "88888888888" === t || "99999999999" === t || "00000000000" === t) return !1;
        for (var r, e, n = 1; n <= 9; n++) r += parseInt(t.substring(n - 1, n), 10) * (11 - n);
        if (10 == (e = 10 * r % 11) && (e = 0), e !== parseInt(t.substring(9, 10), 10)) return !1;
        r = 0;
        for (var a = 1; a <= 10; a++) r += parseInt(t.substring(a - 1, a), 10) * (12 - a);
        return 10 == (e = 10 * r % 11) && (e = 0), e === parseInt(t.substring(10, 11), 10);
      }
      if ("00000000000000" === t || "11111111111111" === t || "22222222222222" === t || "33333333333333" === t || "44444444444444" === t || "55555555555555" === t || "66666666666666" === t || "77777777777777" === t || "88888888888888" === t || "99999999999999" === t) return !1;
      for (var c = t.length - 2, i = t.substring(0, c), s = t.substring(c), o = 0, l = c - 7, u = c; u >= 1; u--) o += i.charAt(c - u) * l, (l -= 1) < 2 && (l = 9);
      var f = o % 11 < 2 ? 0 : 11 - o % 11;
      if (f !== parseInt(s.charAt(0), 10)) return !1;
      c += 1, i = t.substring(0, c), o = 0, l = c - 7;
      for (var p = c; p >= 1; p--) o += i.charAt(c - p) * l, (l -= 1) < 2 && (l = 9);
      return (f = o % 11 < 2 ? 0 : 11 - o % 11) === parseInt(s.charAt(1), 10);
    },
    "pt-PT": function ptPT(t) {
      var r = 11 - s.reverseMultiplyAndSum(t.split("").slice(0, 8).map(function (t) {
        return parseInt(t, 10);
      }), 9) % 11;
      return r > 9 ? 0 === parseInt(t[8], 10) : r === parseInt(t[8], 10);
    },
    "ro-RO": function roRO(t) {
      if ("9000" !== t.slice(0, 4)) {
        var r = t.slice(1, 3);
        switch (t[0]) {
          case "1":
          case "2":
            r = "19".concat(r);
            break;
          case "3":
          case "4":
            r = "18".concat(r);
            break;
          case "5":
          case "6":
            r = "20".concat(r);
        }
        var e = "".concat(r, "/").concat(t.slice(3, 5), "/").concat(t.slice(5, 7));
        if (8 === e.length) {
          if (!(0, o.default)(e, "YY/MM/DD")) return !1;
        } else if (!(0, o.default)(e, "YYYY/MM/DD")) return !1;
        for (var n = t.split("").map(function (t) {
            return parseInt(t, 10);
          }), a = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], c = 0, i = 0; i < a.length; i++) c += n[i] * a[i];
        return c % 11 == 10 ? 1 === n[12] : n[12] === c % 11;
      }
      return !0;
    },
    "sk-SK": function skSK(t) {
      if (9 === t.length) {
        if ("000" === (t = t.replace(/\W/, "")).slice(6)) return !1;
        var r = parseInt(t.slice(0, 2), 10);
        if (r > 53) return !1;
        r = r < 10 ? "190".concat(r) : "19".concat(r);
        var e = parseInt(t.slice(2, 4), 10);
        e > 50 && (e -= 50), e < 10 && (e = "0".concat(e));
        var n = "".concat(r, "/").concat(e, "/").concat(t.slice(4, 6));
        if (!(0, o.default)(n, "YYYY/MM/DD")) return !1;
      }
      return !0;
    },
    "sl-SI": function slSI(t) {
      var r = 11 - s.reverseMultiplyAndSum(t.split("").slice(0, 7).map(function (t) {
        return parseInt(t, 10);
      }), 8) % 11;
      return 10 === r ? 0 === parseInt(t[7], 10) : r === parseInt(t[7], 10);
    },
    "sv-SE": function svSE(t) {
      var r = t.slice(0);
      t.length > 11 && (r = r.slice(2));
      var e = "",
        n = r.slice(2, 4),
        a = parseInt(r.slice(4, 6), 10);
      if (t.length > 11) e = t.slice(0, 4);else if (e = t.slice(0, 2), 11 === t.length && a < 60) {
        var c = new Date().getFullYear().toString(),
          i = parseInt(c.slice(0, 2), 10);
        if (c = parseInt(c, 10), "-" === t[6]) e = parseInt("".concat(i).concat(e), 10) > c ? "".concat(i - 1).concat(e) : "".concat(i).concat(e);else if (c - parseInt(e = "".concat(i - 1).concat(e), 10) < 100) return !1;
      }
      a > 60 && (a -= 60), a < 10 && (a = "0".concat(a));
      var l = "".concat(e, "/").concat(n, "/").concat(a);
      if (8 === l.length) {
        if (!(0, o.default)(l, "YY/MM/DD")) return !1;
      } else if (!(0, o.default)(l, "YYYY/MM/DD")) return !1;
      return s.luhnCheck(t.replace(/\W/, ""));
    }
  };
  h["lb-LU"] = h["fr-LU"], h["lt-LT"] = h["et-EE"], h["nl-BE"] = h["fr-BE"];
  var I = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g,
    g = {
      "de-AT": I,
      "de-DE": /[\/\\]/g,
      "fr-BE": I
    };
  g["nl-BE"] = g["fr-BE"], t.exports = a.default, t.exports.default = a.default;
}(t, t.exports);
var a = t.exports;
export { a as i };